import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import heroFallback from "../../../assets/img/treydora_redesign/homepage/Hero.png";
import heroWebp from "../../../assets/img/treydora_redesign/homepage/Hero.webp";
import { SITE_NAV_ROUTES } from "../../../constants/siteNavRoutes";
import { trackHomepageCtaClick } from "../../../utils/analytics";

const tags = [
  "Dark Sci-Fi Fantasy",
  "Novel & NFT Comic",
  "TRDX Game Access",
  "Oshar · Marketplace Next",
];

const HomeRpgHero = () => {
  return (
    <section className="td-rpg-hero" aria-label="Hero">
      <picture className="td-rpg-hero__bg">
        <source srcSet={heroWebp} type="image/webp" />
        <img
          src={heroFallback}
          alt=""
          width="1672"
          height="941"
          fetchPriority="high"
          decoding="sync"
        />
      </picture>
      <div className="td-rpg-inner">
        <div className="td-rpg-hero__content">
          <h1 className="td-rpg-hero__title">TREYDORA: RISE OF KORAXOS</h1>
          <p className="td-rpg-hero__lead">
            A dark sci-fi fantasy game universe — the Koraxos novel and Genesis NFT comic
            are live now; TRDX unlocks game access; Oshar VR estates and the marketplace
            are open on Treydora.com.
          </p>
          <div className="td-rpg-hero__ctas">
            <Link
              to={SITE_NAV_ROUTES.PUBLIC_LIBRARY}
              className="td-btn-gold"
              onClick={() =>
                trackHomepageCtaClick({
                  cta_id: "hero_explore_library",
                  section: "hero",
                  destination: SITE_NAV_ROUTES.PUBLIC_LIBRARY,
                })
              }
            >
              Explore the Library
            </Link>
            <HashLink
              smooth
              to={SITE_NAV_ROUTES.TOKEN_SALE}
              className="td-btn-outline"
              onClick={() =>
                trackHomepageCtaClick({
                  cta_id: "hero_trdx_access",
                  section: "hero",
                  destination: SITE_NAV_ROUTES.TOKEN_SALE,
                })
              }
            >
              <i className="fas fa-coins" style={{ marginRight: 8 }} aria-hidden />
              Treydorex (TRDX) access
            </HashLink>
            <Link
              to={SITE_NAV_ROUTES.WORLD}
              className="td-btn-outline"
              onClick={() =>
                trackHomepageCtaClick({
                  cta_id: "hero_world_of_oshar",
                  section: "hero",
                  destination: SITE_NAV_ROUTES.WORLD,
                })
              }
            >
              World of Oshar
            </Link>
          </div>
          <div className="td-rpg-hero__tags">
            {tags.map((t) => (
              <span key={t} className="td-rpg-tag">
                <i className="fas fa-gem" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeRpgHero;
